import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { formatDateToTodayTime } from "../../../../common/common";

let settigsPage = [
    // { id: 'collection-page', label: 'Collection Page', value: 1 },
    { id: 'product-page', label: 'Product Page', value: 2 },
    { id: 'cart-page', label: 'Cart Page', value: 3 },
    { id: 'cart-drawer-page', label: 'Cart Drawer Page', value: 4 },
    { id: 'checkout-page', label: 'Checkout Page', value: 5 },
    { id: 'post-purchase-page', label: 'Post-Purchase Page', value: 6 },
  ]

const AssignmentLogsModal = ({ onClose,
    currentAnalysisData,
    order_details_id,
    selectedSkuReport,
    antecedentProductData
 }) => {

    const navigate = useNavigate();
    const [mainSkuLogs,setMainSkuLogs] = useState([])

    const getPushedSkuListDataLogs = async () => {
        try {
    
          const response = await axios.get(
            `${process.env.REACT_APP_API_END_POINT}/ecommerce/list-pushed-data-logs?analysis_details_id=${currentAnalysisData._id}&order_details_id=${order_details_id}&sku_reports_id=${selectedSkuReport._id}&main_sku=${antecedentProductData.sku}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          setMainSkuLogs(response.data.data.reverse())

        } catch (error) {
          if (error.response.data?.detail?.isExpireToken) {
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            navigate("/login")
          }
          toast.error(error.response?.data?.message || error.message);
        }
    }

    useEffect(()=>{
        getPushedSkuListDataLogs()
    },[])

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
      <div className="bg-white rounded-xl w-full max-w-7xl shadow-lg overflow-hidden">
        <div className="px-6 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-800">Assignment Logs</h2>
        </div>
        <div className="overflow-y-auto max-h-[70vh]">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 text-left text-sm font-semibold text-gray-700">
              <tr>
                <th className="px-6 py-3">DATE</th>
                <th className="px-6 py-3">PRODUCT</th>
                <th className="px-6 py-3">Along With Product</th>

                <th className="px-6 py-3">ACTION</th>
                <th className="px-6 py-3">PAGE</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100 text-sm text-gray-700">
                {mainSkuLogs.length === 0 ? (
                    <tr>
                    <td colSpan={4} className="px-6 py-4 text-center text-gray-500">
                        No logs found
                    </td>
                    </tr>
                ) : (
                    mainSkuLogs.map((log, index) => (
                    <tr key={index}>
                        <td className="px-6 py-3">{formatDateToTodayTime(log.createdAt)}</td>
                        <td className="px-6 py-3 font-medium text-gray-900">
                        {log.mainSku}
                        </td>
                        <td className="px-6 py-3 font-medium text-gray-900">
                        {log.pushedSku.join(", ")}
                        </td>
                        <td className="px-6 py-3">
                        <span
                            className={`px-2 py-1 text-xs font-medium rounded-full ${
                            log.type === "saved" 
                                ? "bg-yellow-100 text-yellow-800"
                                : log.type === "removed"
                                ? "bg-indigo-100 text-indigo-800"
                                : log.type === "pushed"
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                            }`}
                        >
                            {log.type}
                        </span>
                        </td>
                        <td className="px-6 py-3">
                        {settigsPage.find((item) => item.value == log.pushedSettings)?.label || "-"}
                        </td>
                    </tr>
                    ))
                )}
                </tbody>

          </table>
        </div>
        <div className="flex justify-end px-6 py-3 border-t">
          <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignmentLogsModal;
